import {SupportedLocales} from '#lit/types/locale.js';
import {AudienceShowTabs} from '#lit/types/audiences.js';
import {enumToI18nObject} from '#lit/common/locale/utils.js';

export const audiencesLocale = {
  [SupportedLocales.EN]: {
    audiencesTable: {
      tagsFilter: {
        placeholder: 'Tags',
        emptyMessage: 'There are no tags available to filter with.',
      },
      datasetGroupFilter: {
        placeholder: 'Dataset Group',
      },
      destinationFilter: {
        placeholder: 'Destination',
      },
      creatorFilter: {
        placeholder: 'Creator',
      },
      searchText: 'Search',
    },
    show: {
      cannotEdit:
        'This audience is either being used in a journey or being exported.',
      tabs: enumToI18nObject(AudienceShowTabs),
      insights: {
        ads: 'Ads',
        email: 'Email',
        filterByDestination: 'Filter by Destination',
        viewMoreInsights: 'View more Insights',
        showAll: 'Show All',
        noDestinations: '(no results to filter)',
      },
    },
    reportHead: {
      heading: 'Audience Report',
      lastUpdated: 'Last Updated: ',
      errorMessage: 'There was an error with your request.',
    },
    exportActivities: {
      modal: {
        titleLabel: 'Audience Export Failures',
        audienceIdLabel: 'Audience ID',
        platformLabel: 'Platform',
        platformTooltip: 'Platform Exporting to',
        successfulRecordsLabel: 'Successful Records',
        successfulRecordsTooltip: 'Records successfully exported',
        rejectedRecordsLabel: 'Rejected Records',
        rejectedRecordsTooltip: 'Records that were not exported',
      },
    },
  },
  [SupportedLocales.ES]: {
    audiencesTable: {
      tagsFilter: {
        placeholder: 'Etiquetas',
        emptyMessage: 'No hay etiquetas disponibles para filtrar.',
      },
      datasetGroupFilter: {
        placeholder: 'Grupo de Conjuntos de Datos',
      },
      destinationFilter: {
        placeholder: 'Destino',
      },
      creatorFilter: {
        placeholder: 'Creador',
      },
      searchText: 'Buscar',
    },
    show: {
      cannotEdit:
        'Esta audiencia está siendo utilizada en un viaje o está siendo exportada.',
      tabs: {
        [AudienceShowTabs.AUDIENCES]: 'Audiencias',
        [AudienceShowTabs.PERFORMANCE]: 'Rendimiento',
        [AudienceShowTabs.INSIGHTS]: 'Insights',
        [AudienceShowTabs.EXPORTS]: 'Exportadas',
        [AudienceShowTabs.QUERIES]: 'Consultas',
      },
      insights: {
        ads: 'Anuncios',
        email: 'Correo Electrónico',
        filterByDestination: 'Filtrar por Destino',
        viewMoreInsights: 'Ver más Insights',
        showAll: 'Mostrar todo',
        noDestinations: '(no hay resultados para filtrar)',
      },
    },
    reportHead: {
      heading: 'Informe de Audiencia',
      lastUpdated: 'Última Actualización: ',
      errorMessage: 'Hubo un error con tu solicitud.',
    },
    exportActivities: {
      modal: {
        titleLabel: 'Audience Export Failures',
        audienceIdLabel: 'ID de Audiencia',
        platformLabel: 'Plataforma',
        platformTooltip: 'Plataforma hacia donde se exporta',
        successfulRecordsLabel: 'Registros Exitosos',
        successfulRecordsTooltip: 'Registros exportados exitosamente',
        rejectedRecordsLabel: 'Registros Rechazados',
        rejectedRecordsTooltip: 'Registros que no se exportaron',
      },
    },
  },
};
